import {Injectable} from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import {Observable, of} from 'rxjs';
import {CommunityDetailsService} from '@app/components/projects/communities/community-details.service';

@Injectable({
  providedIn: 'root'
})
export class CommunitiesResolver  {

  constructor(
    private communityDetailsService: CommunityDetailsService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    console.log('[CommunitiesResolver] route.routeConfig.path', route.routeConfig.path);

    switch (route.routeConfig.path) {
      case 'community/:comId':
        const {comId} = route.params;
        this.communityDetailsService.setId(comId);
        return of(true);
        break;

      default:
        return of(false);

    }

  }
}
